import { motion } from "framer-motion";
import { recommendationRankMovement } from "../utils/tmdbMetadata.mjs";
import MoviePoster from "./MoviePoster";
import MoviePosterPreview from "./MoviePosterPreview";

export default function RecommendationGrid({ movies, previousMovies, system }) {
  if (!movies.length) return null;
  const tears = system === "TEARS";
  return (
    <div className="mt-6">
      <h2 className={`text-md font-bold mb-3 ${tears ? "text-[#80E7FF]" : "text-green-300"}`}>
        Recommended Movies{tears ? "" : ":"}
      </h2>
      <div data-recommendation-grid className="grid grid-cols-2 sm:grid-cols-3 gap-3 sm:gap-4">
        {movies.map(movie => {
          const movement = recommendationRankMovement(movie, previousMovies);
          const urls = [movie.poster_url, ...(movie.poster_urls || [])];
          return (
            <MoviePosterPreview key={movie.movie_id} movieId={movie.movie_id} title={movie.title}
              urls={urls} overview={movie.overview} tmdbId={movie.tmdb_id} imdbId={movie.imdb_id}
              year={movie.year} rating={movie.tmdb_metadata?.rating ?? movie.rating} genres={movie.genres}>
              <motion.div data-recommendation-movie-id={movie.movie_id} tabIndex={0}
                whileHover={{ scale: 1.08 }}
                className={`relative cursor-pointer rounded-xl p-[3px] transition-all ring-1 ring-white/10 z-10 hover:z-20 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white ${tears
                  ? "hover:ring-[#00C8FF88] hover:shadow-[0_0_20px_#00C8FF55]"
                  : "hover:ring-green-400 hover:shadow-[0_0_20px_#00ff9955]"}`}>
                <MoviePoster movieId={movie.movie_id} title={movie.title} urls={urls} />
                <div className="mt-1 flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-xs">
                  <span className={`text-sm font-semibold leading-4 tabular-nums ${tears ? "text-[#80E7FF]" : "text-green-300"}`}>{movie.rank_label || `#${movie.rank}`}</span>
                  {movement?.direction === "new" ? (
                    <span className="font-semibold text-sky-300" aria-label="New recommendation">New</span>
                  ) : movement && (
                    <span aria-label={`Moved ${movement.direction} ${movement.positions} ${movement.positions === 1 ? "position" : "positions"}`}
                      className={`inline-flex items-center gap-1 whitespace-nowrap leading-4 ${movement.direction === "up" ? "text-emerald-200" : "text-rose-200"}`}>
                      <span className="text-lg font-black leading-4">{movement.symbol}</span>{" "}
                      <span className="text-sm font-bold leading-4 tabular-nums">{movement.positions}</span>
                    </span>
                  )}
                </div>
                <h3 className="mt-1 break-words text-sm font-normal text-center leading-snug">{movie.title}</h3>
              </motion.div>
            </MoviePosterPreview>
          );
        })}
      </div>
    </div>
  );
}
